import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SliderWebAyComponent } from "./slider-web-ay.component";
import { ButtonModule } from "@jack-sparrow-libraries/ui-kit";
import { SliderWebAyService } from "@shared-ay/slider-web-ay/slider-web-ay.service";
import { SlideItemWebAyComponent } from "@shared-ay/slider-web-ay/slide-item-web-ay/slide-item-web-ay.component";

@NgModule({
	declarations: [SliderWebAyComponent, SlideItemWebAyComponent],
	imports: [CommonModule, ButtonModule],
	exports: [SliderWebAyComponent, SlideItemWebAyComponent],
	providers: [SliderWebAyService],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SliderWebAyModule {}
